import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CdkScrollableModule} from '@angular/cdk/scrolling';
import {AdminRootComponent} from './admin-root/admin-root.component';
import {PublicRootComponent} from './public-root/public-root.component';
import {RouterModule} from '@angular/router';
import {PartialsModule} from '../partials/partials.module';
import {NotificationsModule} from "@app/modules/notifications/notifications.module";
import {ChatBotComponent} from "@app/partials/chat-bot/chat-bot.component";
import {SafariScreenFixService} from "@app/services/safari-screen-fix.service";
import {VersionToggleBannerComponent} from '@app/shared/v2/version-toggle-banner/version-toggle-banner.component';

@NgModule({
  declarations: [
    PublicRootComponent,
    AdminRootComponent,
  ],
  imports: [
    CommonModule,
    CdkScrollableModule,
    RouterModule,
    PartialsModule,
    NotificationsModule,
    ChatBotComponent,
    VersionToggleBannerComponent,
  ],
  exports: [
    PublicRootComponent,
    AdminRootComponent,
  ],
  providers: [
    SafariScreenFixService
  ]
})
export class RootsModule {
}
